import { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getTranslation } from '../i18n';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
};

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const getLanguageFromPath = () => {
    const pathParts = location.pathname.split('/');
    const langFromPath = pathParts[1];
    return (langFromPath === 'en' || langFromPath === 'pt') ? langFromPath : null;
  };

  const [language, setLanguageState] = useState(() => {
    return getLanguageFromPath() || localStorage.getItem('processsurge-language') || 'pt';
  });

  const baseTranslation = getTranslation(language);

  // Injetando as falas do Carlinhos nas traduções existentes
  const t = {
    ...baseTranslation,
    carlinhos: language === 'pt' ? {
      whatsapp: "Tô com o painel aberto, bora analisar seus dados?",
      contact: "Pode preencher, eu mesmo entrego pro time!",
      pricing: "Psst... esse investimento volta rápido, confia!",
      peek: "Tudo sob controle por aqui!",
      welcome: "Fala aí! Qual o seu maior gargalo hoje?"
    } : {
      whatsapp: "I've got the dashboard open, let's check your data?",
      contact: "Go ahead, I'll personally deliver it to the team!",
      pricing: "Psst... this investment pays off fast, trust me!",
      peek: "Everything is under control!",
      welcome: "Hey there! What is your biggest bottleneck today?"
    }
  };

  const setLanguage = (newLang) => {
    if (newLang !== 'pt' && newLang !== 'en') return;
    localStorage.setItem('processsurge-language', newLang);
    setLanguageState(newLang);
    const currentPath = location.pathname.split('/').filter(Boolean);
    if (currentPath[0] === 'pt' || currentPath[0] === 'en') currentPath.shift();
    navigate(`/${newLang}/${currentPath.join('/')}`, { replace: true });
  };

  useEffect(() => {
    const pathLang = getLanguageFromPath();
    if (pathLang && pathLang !== language) setLanguageState(pathLang);
  }, [location.pathname]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage: () => setLanguage(language === 'pt' ? 'en' : 'pt') }}>
      {children}
    </LanguageContext.Provider>
  );
};
